var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.7188 17.7812C28 17.5312 28.2656 17.5312 28.5156 17.7812L38.3125 27.625C38.5938 27.875 38.5938 28.125 38.3125 28.375L28.5156 38.2188C28.2656 38.4688 28 38.4688 27.7188 38.2188L26.7812 37.2812C26.6875 37.1875 26.6406 37.0625 26.6406 36.9062C26.6406 36.75 26.6875 36.6094 26.7812 36.4844L34.0469 29.2188H18.0625C17.6875 29.2188 17.5 29.0312 17.5 28.6562V27.3438C17.5 26.9688 17.6875 26.7812 18.0625 26.7812H34.0469L26.7812 19.5156C26.5312 19.2344 26.5312 18.9688 26.7812 18.7188L27.7188 17.7812Z",
    fill: "#9CA5B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/Next_button.f01a16c3e8e5ad732ef5a056cdbb7744.svg";
export { ForwardRef as ReactComponent };